module.exports = __webpack_public_path__ + "static/media/img-mobile-offer@2x.00ff2d06.png";